import { loginCallback } from "./google-login.service";

export const googleLoginService = { loginCallback };
